import { ReactElement } from "react";
import { Card, Text } from "@jsq/ds/core";
import { displayValueOrDash } from "~/pages/Billing/utils";
import { overviewTitle, overviewContent, overviewRow } from "./styles_vanilla.css";

interface ClientData {
  clientId: number | null;
  arenaId: number | null;
  accountManager: string | null;
  customerSuccessManager: string | null;
  renewalDate: string | null;
  deploymentDate: string | null;
  contractStartDate: string | null;
}

interface OverviewCardProps {
  clientData: ClientData;
}

export const OverviewCard = ({ clientData }: OverviewCardProps): ReactElement => {
  const displayValue = (value: string | number | null | undefined): string => {
    if (value === null || value === undefined) return "-";
    return String(value);
  };

  return (
    <Card>
      <Text variant="h3" className={overviewTitle}>
        Overview
      </Text>
      <div className={overviewContent}>
        <div className={overviewRow}>
          <Text>Client ID</Text>
          <Text>{displayValue(clientData.clientId)}</Text>
        </div>
        <div className={overviewRow}>
          <Text>Arena ID</Text>
          <Text>{displayValue(clientData.arenaId)}</Text>
        </div>
        <div className={overviewRow}>
          <Text>Account manager</Text>
          <Text>{displayValue(clientData.accountManager)}</Text>
        </div>
        <div className={overviewRow}>
          <Text>Customer success manager</Text>
          <Text>{displayValue(clientData.customerSuccessManager)}</Text>
        </div>
        <div className={overviewRow}>
          <Text>Renewal date</Text>
          <Text>{displayValueOrDash(clientData.renewalDate)}</Text>
        </div>
        <div className={overviewRow}>
          <Text>Deployment date</Text>
          <Text>{displayValueOrDash(clientData.deploymentDate)}</Text>
        </div>
        <div className={overviewRow}>
          <Text>Contract start date</Text>
          <Text>{displayValueOrDash(clientData.contractStartDate)}</Text>
        </div>
      </div>
    </Card>
  );
};
